/**
 * Shared formatting utilities for Line Dance Central
 * Used across Shop, Weekender, and other components
 */

/**
 * Format a number as GBP currency
 * @param {number} amount - The amount to format
 * @returns {string} Formatted currency string (e.g., "£19.99")
 */
export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-GB', { 
    style: 'currency', 
    currency: 'GBP' 
  }).format(amount || 0);
}

/**
 * Format a date string for display with time
 * Used in Shop orders and similar contexts where time matters
 * @param {string} dateStr - ISO date string
 * @returns {string} Formatted date string (e.g., "8 Dec 2025, 14:30")
 */
export function formatDateTimeShort(dateStr) {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return '-';
  }
}

/**
 * Format a date string for display (date only, no time)
 * @param {string} dateStr - ISO date string
 * @returns {string} Formatted date string (e.g., "8 Dec 2025")
 */
export function formatDateShort(dateStr) {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return '-';
  }
}
